import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { resetDateRange, setFeatureFlags } from "../store/features/globalSlice";
import ScrollToTop from "./useScrollToTop";
import useFeatureFlag from "./useFeatureFlag";
import { useQueryClient } from "@tanstack/react-query";

export default function useRouteChange() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const { flags } = useFeatureFlag();

  useEffect(() => {
    dispatch(setFeatureFlags(flags));
  }, [flags]);

  useEffect(() => {
    dispatch(resetDateRange());
    queryClient.invalidateQueries(["featureFlag"]);
  }, [pathname, dispatch]);

  return (
    <>
      <ScrollToTop />
    </>
  );
}
